const appRoutes = {
	INDEX: "/",
	DASHBOARD: "/dashboard",
	LOGIN: "/login",
};

export const dashboardRoutes = {
	SALES: "/sales",
	ADDSALESRECORD: "/addsalesrecord",
	ADDSALESRETURN: "/addsalesreturn",
	PURCHASES: "/purchases",
	ADDPURCHASERECORD: "/addpurchaserecord",
	VIEWPRODUCTS: "/products",
	ADDPRODUCTS: "/addproduct",
	VIEWCATEGORIES: "/categories",
	ADDCATEGORY: "/addcategory",
	VIEWSUPPLIERS: "/suppliers",
	ADDSUPPLIER: "/addsupplier",
	VIEWINVENTORY: "/inventory",
	ADDSTOCKRETURN: "/addreturnedstock",
	ADDSTOCKDAMAGED: "/adddamagedstock",
	VIEWLEDGER: "/ledger",
};

export default appRoutes;
